const e = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "_admin",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "bool",
        name: "_enabled",
        type: "bool"
      }
    ],
    name: "AdminAccessSet",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "previousAdmin",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "newAdmin",
        type: "address"
      }
    ],
    name: "AdminChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "beacon",
        type: "address"
      }
    ],
    name: "BeaconUpgraded",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "_planetOwner",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "_planetID",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "string",
        name: "_seedPlanetID",
        type: "string"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "_slotsWithApostleIDs",
        type: "uint256[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "_apostleIDs",
        type: "uint256[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "_genes",
        type: "uint256[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "_ivs",
        type: "uint256[]"
      },
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "_createTimes",
        type: "uint256[]"
      },
      {
        indexed: !1,
        internalType: "enum RelicApostleManagement.ACTION_TYPE[]",
        name: "_actions",
        type: "uint8[]"
      }
    ],
    name: "ManageRelicApostle",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "_planetOwner",
        type: "address"
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "planetID",
            type: "uint256"
          },
          {
            internalType: "string",
            name: "seedPlanetID",
            type: "string"
          },
          {
            internalType: "uint256[]",
            name: "slotsWithApostleIDs",
            type: "uint256[]"
          },
          {
            internalType: "uint256[]",
            name: "apostleIDs",
            type: "uint256[]"
          },
          {
            internalType: "uint256[]",
            name: "genes",
            type: "uint256[]"
          },
          {
            internalType: "uint256[]",
            name: "ivs",
            type: "uint256[]"
          },
          {
            internalType: "uint256[]",
            name: "createTimes",
            type: "uint256[]"
          },
          {
            internalType: "enum RelicApostleManagement.ACTION_TYPE[]",
            name: "actions",
            type: "uint8[]"
          }
        ],
        indexed: !1,
        internalType: "struct RelicApostleManagement.ApostlePayload[]",
        name: "_payloads",
        type: "tuple[]"
      }
    ],
    name: "ManageRelicApostlesSummary",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "_reforgingPriceArray",
        type: "uint256[]"
      }
    ],
    name: "ReforgePriceUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint8",
        name: "_mintType",
        type: "uint8"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "_saleSchedule",
        type: "uint256"
      }
    ],
    name: "SaleScheduleUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "implementation",
        type: "address"
      }
    ],
    name: "Upgraded",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_planetWithSlotId",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_targetPlanetId",
        type: "uint256"
      }
    ],
    name: "coverPlanetSlotsWithApostleIDsMapping",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "_planetIDs",
        type: "uint256[]"
      },
      {
        internalType: "string[]",
        name: "_seedPlanetIDs",
        type: "string[]"
      }
    ],
    name: "getPlanetNonceArray",
    outputs: [
      {
        internalType: "uint256[]",
        name: "planetResult",
        type: "uint256[]"
      },
      {
        internalType: "uint256[]",
        name: "seedPlanetResult",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "_planetIds",
        type: "uint256[]"
      },
      {
        internalType: "string[]",
        name: "_seedPlanetIds",
        type: "string[]"
      }
    ],
    name: "getPlanetSlotsWithApostleIDsMapping",
    outputs: [
      {
        internalType: "uint256[][]",
        name: "",
        type: "uint256[][]"
      },
      {
        internalType: "uint256[][]",
        name: "",
        type: "uint256[][]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getReforgingAnimaPriceArray",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address"
      }
    ],
    name: "isAdmin",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "planetID",
            type: "uint256"
          },
          {
            internalType: "string",
            name: "seedPlanetID",
            type: "string"
          },
          {
            internalType: "uint256[]",
            name: "slotsWithApostleIDs",
            type: "uint256[]"
          },
          {
            internalType: "uint256[]",
            name: "apostleIDs",
            type: "uint256[]"
          },
          {
            internalType: "uint256[]",
            name: "genes",
            type: "uint256[]"
          },
          {
            internalType: "uint256[]",
            name: "ivs",
            type: "uint256[]"
          },
          {
            internalType: "uint256[]",
            name: "createTimes",
            type: "uint256[]"
          },
          {
            internalType: "enum RelicApostleManagement.ACTION_TYPE[]",
            name: "actions",
            type: "uint8[]"
          }
        ],
        internalType: "struct RelicApostleManagement.ApostlePayload[]",
        name: "_payloads",
        type: "tuple[]"
      },
      {
        internalType: "uint256",
        name: "_time",
        type: "uint256"
      },
      {
        internalType: "bytes",
        name: "_signature",
        type: "bytes"
      }
    ],
    name: "manageRelicApostles",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "admin",
        type: "address"
      },
      {
        internalType: "bool",
        name: "enabled",
        type: "bool"
      }
    ],
    name: "setAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_isEnabled",
        type: "bool"
      }
    ],
    name: "setEnabled",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "_reforgingPriceArray",
        type: "uint256[]"
      }
    ],
    name: "setupReforgePrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenReceiptHandler",
        type: "address"
      },
      {
        internalType: "address",
        name: "_planetAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_apostleAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_animaAddress",
        type: "address"
      },
      {
        internalType: "address",
        name: "_systemAddress",
        type: "address"
      }
    ],
    name: "updateContractSetting",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address"
      }
    ],
    name: "upgradeTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "address",
        name: "_wallet",
        type: "address"
      }
    ],
    name: "withdrawFunds",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
export {
  e as default
};
//# sourceMappingURL=ronin-planet-apostle-manage.json.js.map
